import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontIndivisibleVariable, fontPlayfairDisplay, fontSourceSerif4 } from "shared/lib/styles";

import { responsiveStyles } from "scmp-app/components/header/features/styles";
import type { ResponsiveStyledProps } from "scmp-app/components/header/features/types";

type ContainerProps = ResponsiveStyledProps & {
  $isMagazineStyle?: boolean;
  $isPostMagazineArticle?: boolean;
};

export const Container = styled.div<ContainerProps>`
  position: relative;

  min-inline-size: 0;
  max-inline-size: 70%;
  margin-inline-start: 12px;
  padding-inline-start: 12px;

  color: #000000;
  font-weight: 600;
  font-size: 12px;
  font-family: ${fontSourceSerif4};
  line-height: 18px;
  white-space: nowrap;
  text-overflow: ellipsis;

  overflow: hidden;

  &::before {
    position: absolute;
    inset-block-start: 50%;
    inset-inline-start: 0;
    content: "";

    display: block;

    inline-size: 1px;
    block-size: 12px;

    background-color: #001246;

    transform: translateY(-50%);
  }

  ${({ $isMagazineStyle }) =>
    $isMagazineStyle &&
    css`
      color: #000000;
      font-size: 14px;
      font-family: ${fontPlayfairDisplay};
      line-height: 19px;
    `}

  ${({ $isPostMagazineArticle }) =>
    $isPostMagazineArticle &&
    css`
      color: #111111;
      font-weight: 400;
      font-size: 13px;
      font-family: ${fontIndivisibleVariable};
      font-style: normal;
      line-height: normal;
      letter-spacing: -0.013px;
    `}

  ${responsiveStyles}
`;
